export default "__VITE_ASSET__B9v4sySp__"